import { OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AmplitudeService } from '../../shared/services/amplitude.service';
var DownloadWidgetComponent = /** @class */ (function () {
    function DownloadWidgetComponent(amplitudeService) {
        this.amplitudeService = amplitudeService;
    }
    DownloadWidgetComponent.prototype.ngOnInit = function () { };
    DownloadWidgetComponent.prototype.install = function () {
        this.amplitudeService.logEvent('Panel:Widget:Install');
    };
    Object.defineProperty(DownloadWidgetComponent.prototype, "getWidgetUrl", {
        get: function () {
            return "https://chrome.google.com/webstore/detail/" + environment.CHROME_STORE_WIDGET_ID;
        },
        enumerable: true,
        configurable: true
    });
    return DownloadWidgetComponent;
}());
export { DownloadWidgetComponent };
